import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as s}from"../../icon-registry.js";const h=s("arrow_back_2",t`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_18095_54522"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24">
                <rect
                    width="24"
                    height="24"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_18095_54522)">
                <path
                    d="M3.46753 13.3767C3.22461 13.2148 3.04242 13.0124 2.92096 12.7694C2.7995 12.5265 2.73877 12.2701 2.73877 12.0002C2.73877 11.7303 2.7995 11.4739 2.92096 11.2309C3.04242 10.988 3.22461 10.7856 3.46753 10.6237L16.6662 2.24292C16.8011 2.16195 16.9428 2.10122 17.0913 2.06073C17.2397 2.02024 17.3814 2 17.5164 2C17.9482 2 18.3261 2.1552 18.65 2.4656C18.9739 2.77599 19.1359 3.16062 19.1359 3.61946V20.3809C19.1359 20.8398 18.9739 21.2244 18.65 21.5348C18.3261 21.8452 17.9482 22.0004 17.5164 22.0004C17.3814 22.0004 17.2397 21.9801 17.0913 21.9397C16.9428 21.8992 16.8011 21.8384 16.6662 21.7575L3.46753 13.3767ZM15.8969 17.4254V6.57499L7.39473 12.0002L15.8969 17.4254Z"
                    fill="#FCFCFC" />
            </g>
        </svg>
    `),l=s("arrow_back_2_filled",t`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_18095_54522"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24">
                <rect
                    width="24"
                    height="24"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_18095_54522)">
                <path
                    d="M3.50001 13.3704C3.25815 13.2091 3.07675 13.0076 2.95581 12.7657C2.83488 12.5238 2.77441 12.2685 2.77441 11.9998C2.77441 11.7311 2.83488 11.4758 2.95581 11.2339C3.07675 10.992 3.25815 10.7905 3.50001 10.6292L16.6414 2.28484C16.7758 2.20421 16.9169 2.14375 17.0647 2.10344C17.2125 2.06312 17.3536 2.04297 17.488 2.04297C17.9179 2.04297 18.2942 2.19749 18.6167 2.50655C18.9392 2.8156 19.1004 3.19855 19.1004 3.65541V20.3442C19.1004 20.8011 18.9392 21.184 18.6167 21.4931C18.2942 21.8021 17.9179 21.9566 17.488 21.9566C17.3536 21.9566 17.2125 21.9365 17.0647 21.8962C16.9169 21.8559 16.7758 21.7954 16.6414 21.7148L3.50001 13.3704Z"
                    fill="#FCFCFC" />
            </g>
        </svg>
    `);export{h as ArrowBack2,l as ArrowBack2Filled};
